// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
export interface DatabaseDefinition {
  /** The id of the database. */
  id?: string;
}
